var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseNotificationsGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3052_30411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.80807 1.39307L22.6071 21.1931L21.1921 22.6071L17.5841 18.9991L6.45507 19.0001L2.00007 22.5001V4.00007C2.00007 3.83007 2.04207 3.67107 2.11607 3.53107L1.39307 2.80807L2.80807 1.39307ZM3.99907 5.41307L4.00007 18.3851L5.76307 17.0001H15.5841L4.00007 5.41207L3.99907 5.41307ZM21.0001 3.00007C21.2653 3.00007 21.5196 3.10542 21.7072 3.29296C21.8947 3.4805 22.0001 3.73485 22.0001 4.00007V17.7851L20.0001 15.7851V5.00007L9.21307 4.99907L7.21407 3.00007H21.0001Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3052_30411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseNotificationsGray);
export default __webpack_public_path__ + "static/media/pause_notifications_gray.d9001ab8.svg";
export { ForwardRef as ReactComponent };